import { apiClient } from '@/shared/api/http/client';
import { ENDPOINTS } from '@/shared/api/endpoints';

export interface ConnectionChoiceItem {
  connectionId: string;
  name: string;
  showNumber?: string | null;
  customerName?: string | null;
  customerProductId?: string | null;
}
export interface ConnectionChoiceResponse {
  selectionRequired: boolean;
  resolvedByEmail?: boolean;
  connectionRequired: boolean;
  items: ConnectionChoiceItem[];
}

const opts = { octo: { expectSuccess: false, skipAuth: true } } as const;

export const connectionsApi = {
  list: (refresh = false) => apiClient.get<ConnectionChoiceResponse>(ENDPOINTS.CONNECTIONS(refresh), opts),
  lookupByEmail: (email: string) => apiClient.post<ConnectionChoiceResponse>(ENDPOINTS.CONNECTIONS_LOOKUP, { Email: email }, opts),
  loginCandidates: (userCode: string, password: string) =>
    apiClient.post<ConnectionChoiceResponse>(ENDPOINTS.CONNECTIONS_LOGIN_CANDIDATES, { UserCode: userCode, Password: password }, opts),
};
